import { motion } from 'framer-motion'
import { Edit, Eye, Layout, Users, Check } from 'react-feather'
import AnimatedBackground from '../common/AnimatedBackground'

import './ServiceDetail.css'

export default function UiUxDesign() {
  const technologies = [
    "Figma", "Adobe XD", "Sketch", "InVision",
    "Principle", "Zeplin", "Adobe Creative Suite", "Prototyping Tools"
  ]

  const features = [
    {
      icon: Eye,
      title: "User Research",
      description: "Understanding user needs and behaviors through research."
    },
    {
      icon: Layout,
      title: "Interface Design",
      description: "Creating beautiful and intuitive user interfaces."
    },
    {
      icon: Users,
      title: "User Experience",
      description: "Designing seamless and engaging user journeys."
    },
    {
      icon: Edit,
      title: "Design Systems",
      description: "Building scalable and consistent design systems."
    }
  ]

  return (
    <section className="service-detail-section">
        <AnimatedBackground text="" />
      <div className="service-detail-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="service-detail-header"
        >
          <h1>UI/UX <span className="gradient-text">Design</span></h1>
          <p>Creating delightful digital experiences through user-centered design</p>
        </motion.div>

        <div className="service-content">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="service-description"
          >
            <h2>What We Offer</h2>
            <p>
              Our UI/UX design team creates intuitive and engaging digital 
              experiences that users love. We combine aesthetic excellence with 
              functional design principles to deliver interfaces that not only 
              look beautiful but also provide seamless user experiences that 
              drive engagement and conversion.
            </p>
          </motion.div>

          <div className="features-grid">
            {features.map((feature, index) => {
              const Icon = feature.icon
              return (
                <motion.div
                  key={feature.title}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 + index * 0.1 }}
                  className="feature-card"
                >
                  <Icon className="feature-icon" />
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </motion.div>
              )
            })}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="technologies-section"
          >
            <h2>Tools We Use</h2>
            <div className="technologies-grid">
              {technologies.map((tech, index) => (
                <div key={tech} className="technology-item">
                  <Check className="check-icon" />
                  <span>{tech}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
            className="cta-section"
          >
            <h2>Ready to Transform Your Design?</h2>
            <p>Let's discuss how we can help create amazing user experiences.</p>
            <a href="/contact" className="cta-button">
              Get in Touch
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  )
}